var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoMas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono-3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.53220122%",
    y1: "105.158603%",
    x2: "109.227812%",
    y2: "-4.88625441%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.84%",
    y1: "84.43%",
    x2: "86.97%",
    y2: "15.74%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-DIC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementos-/-icono-3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8380327,38.3380327 C63.8164932,38.3380327 62.2104104,38.3380327 59.0197844,38.3380327 C55.8291584,38.3380327 51.0432193,38.3380327 44.6619673,38.3380327 L44.6619673,19.1619673 C44.6619673,17.415661 43.2463063,16 41.5,16 C39.7536937,16 38.3380327,17.415661 38.3380327,19.1619673 L38.3380327,38.3380327 L19.1619673,38.3380327 C17.415661,38.3380327 16,39.7536937 16,41.5 C16,43.2463063 17.415661,44.6619673 19.1619673,44.6619673 L38.3380327,44.6619673 L38.3380327,63.8380327 C38.3380327,65.584339 39.7536937,67 41.5,67 C43.2463063,67 44.6619673,65.584339 44.6619673,63.8380327 L44.6619673,44.6619673 L63.8380327,44.6619673 C65.584339,44.6619673 67,43.2463063 67,41.5 C67,39.7536937 65.584339,38.3380327 63.8380327,38.3380327 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,82 C18.3563253,82 0,63.6436747 0,41 C0,18.3563253 18.3563253,0 41,0 C63.6436747,0 82,18.3563253 82,41 C81.9728898,63.6324358 63.6324358,81.9728898 41,82 Z M41,5.6744 C21.4902098,5.6744 5.6744,21.4902098 5.6744,41 C5.6744,60.5097902 21.4902098,76.3256 41,76.3256 C60.5097902,76.3256 76.3256,60.5097902 76.3256,41 C76.3030065,21.499576 60.500424,5.69699349 41,5.6744 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoMas);
export default __webpack_public_path__ + "static/media/icono-mas.ed8292fe5f26f08294bc0ed03ea66857.svg";
export { ForwardRef as ReactComponent };